import React from 'react';
import { Image, Text, View } from 'react-native-web';
import {
  Android, kbd_success_icon, keyboard_logo,
} from '../../../../utils/DictionaryManagementUtils';
import { getImageByKey, img_arrow } from '../../../../utils/ImagesManagementUtils';
import OnBoardingTopTitlesIOS from '../../AuxiliaryComponent/MixComponent/OnBoardingTopTitlesIOS';
import LetterKeyboardImage from '../../AuxiliaryComponent/Images/LetterKeyboardImage';
import LargeTextWithSpecialFont from '../../AuxiliaryComponent/TextComponent/LargeTextWithSpecialFont';
import LargeBtnWithFilling from '../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import { textPrimary_10_9, textPrimary_9_2 } from '../../AuxiliaryComponent/TextComponent/TextStyle';
import { getRef } from '../../../../utils/Utils';

//= ========================================================================
const SuccessSelectedKeyboardFP = ({
  globJSON,
  simPlatform,
  language,
  slideshowRefs,
}) => {
  const img_stub = getImageByKey(globJSON.configurations.services.menu.keyboard_logo, keyboard_logo);
  const { colors } = globJSON.configurations.theme;
  const { instructions } = globJSON.configurations.onboarding;

  const img2 = getImageByKey(instructions.kbd_success_icon, kbd_success_icon);
  const myStyles = {
    hotkeyLogo: {
      width: simPlatform === Android ? 23 : 26,
      height: simPlatform === Android ? 23 : 26,
      marginLeft: 6,
      marginTop: simPlatform === Android ? 251 : 306,
      position: 'absolute',
    },
    imgArrow: {
      width: 14,
      height: 18,
      marginLeft: 16,
      marginTop: simPlatform === Android ? 224 : 279,
      position: 'absolute',
      tintColor: colors.primary_cta_color,
    },
    lblBottomLine: {
      width: 86,
      height: 3.2,
      marginLeft: 77,
      marginTop: 509,
      borderRadius: 1.6,
      position: 'absolute',
      backgroundColor: colors.primary_font_color,
    },
    kbd_success_icon: {
      marginLeft: 96,
      marginTop: simPlatform === Android ? 35 : 72,
      width: 48,
      height: 48,
      position: 'absolute',
    },
    TitleStyle: {
      marginTop: simPlatform === Android ? 90 : 30,
      marginBottom: 10,
    },
    firstSentence: {
      marginLeft: simPlatform === Android ? 10 : 19,
      marginTop: simPlatform === Android ? 171 : 231,
      width: simPlatform === Android ? 220 : 192,
      position: 'absolute',
    },
    secondSentence: {
      marginLeft: simPlatform === Android ? 10 : 19,
      marginTop: simPlatform === Android ? 191 : 249,
      width: simPlatform === Android ? 220 : 192,
      position: 'absolute',
    },
  };

  return (
    <View ref={getRef(slideshowRefs)}>
      <LetterKeyboardImage
        globJSON={globJSON}
        simPlatform={simPlatform}
      />

      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.hotkeyLogo}
        source={img_stub}
      />

      {simPlatform !== Android && (
        <OnBoardingTopTitlesIOS
          globJSON={globJSON}
          simPlatform={simPlatform}
        />
      )}

      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.kbd_success_icon}
        source={img2}
      />

      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.imgArrow}
        source={img_arrow}
      />
      <View style={myStyles.TitleStyle}>
        <LargeTextWithSpecialFont
          globJSON={globJSON}
          simPlatform={simPlatform}
          language={language}
          txt={instructions.success}
        />
      </View>
      <LargeBtnWithFilling
        globJSON={globJSON}
        simPlatform={simPlatform}
        inputText={instructions.o_done}
      />

      <Text style={[textPrimary_10_9(globJSON, simPlatform), myStyles.firstSentence]}>
        {instructions.o_i_give_it_a_go}
      </Text>

      <Text style={[textPrimary_9_2(globJSON, simPlatform), myStyles.secondSentence]}>
        {instructions.o_i_tap_the_bank_icon}
      </Text>

      {simPlatform !== Android && <View style={myStyles.lblBottomLine} />}
    </View>
  );
};

export default SuccessSelectedKeyboardFP;
